enum LayoutNodeSequenceType {
  WHOLE_NUMBERS = "whole-numbers"
}

export default LayoutNodeSequenceType;
